import MessageContained from "../../MessageContained";
import { useTableContext } from "./TableContext";

/** Table with NO result content */
const TableNOResult = () => {
    const { columns, noRecordTemplate, loading, noRecordText, noDataPresentLoadingText, developmentUrl } = useTableContext();
    let template: any = noRecordText ?? "No records found.";

    if (noRecordTemplate) {
        if (noRecordTemplate.type === 'MessageContained') {
            template = <MessageContained developmentUrl={developmentUrl} {...noRecordTemplate.props} />
        }
    }

    if (loading) {
        template = noDataPresentLoadingText ?? 'Please wait fetching data from server.';
    }

    return <tr>
        <td colSpan={columns.length}>
            <div className="ted-ui-table-no-result-template">
                {template}
            </div>
        </td>
    </tr>
}

export default TableNOResult;